import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import th from 'vee-validate/dist/locale/th';

// loop over all rules
// extend('atLeastOne', {
//     validate: value => {
//         console.log(value);
//         return false
//         // return this.mailLists.some(list => list.checked);
//     },
//     message: `At least one item must be selected.`
// });


extend('atLeastOne', value => {
    if (value >= 0) {
        return true;
    }

    return {
        valid: 'response.data.valid',
        errors: 'xzxx'
    };
});

for (let rule in rules) {
    extend(rule, {
        ...rules[rule], // add the rule
        message: th.messages[rule] // add its message
    });
}
extend('idcard', {
    validate: value => {
        var val = value
        if (val.toString().length !== 13 || val.toString().includes('.')) {
            return false
        } else {
            return true;
        }
    },
    message: 'เลขบัตรประจำตัวประชาชนต้องเป็นตัวเลขจำนวน 13 หลักเท่านั้น'
});
